import { RouteValidator } from '../RouteValidator';
import { Store } from 'redux';
import { store } from 'src/store';
import { RootState } from 'src/reducers/RootReducer';
import { getProject } from 'src/actions/project/get/GetProject.actions';
import * as getProjectTypes from 'src/actions/project/get/Types';

export default class ProjectFounderService implements RouteValidator {

  private store: Store<RootState> = store;

  public getValidation(): Promise<void> {
    return new Promise(
      (res, error) => {
        const projectId = store.getState().router.location!.pathname.split('/')[3];
        if (this.store.getState().getProject.project &&
          this.store.getState().getProject.project!.id.toString() === projectId) {
          if (this.store.getState().getProject.project!.company!.founderId!.toString() !==
            this.store.getState().getUser.user!.physicalPersonId.toString()) {
            error('projectFounder');
          } else {
            res();
          }
        } else {
          this.store.dispatch(getProject(projectId)).then((response) => {
            if (response.type === getProjectTypes.GET_PROJECT_SUCCESS) {
              if (response.payload.company.founderId!.toString() !==
                this.store.getState().getUser.user!.physicalPersonId.toString()) {
                error('projectFounder');
              } else {
                res();
              }
            }
          });
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/services/route-validation/validators/ProjectFounder.tsx